export default "__VITE_ASSET__B5$LJzbP__"